import React from 'react';

interface CardProps {
  children: React.ReactNode;
  padding?: string;
  variant?: 'solid' | 'glass';
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  padding = 'var(--spacing-lg)', 
  variant = 'solid',
  onClick,
  style,
  className = ''
}) => {
  // Tailwind-based for clean, consistent, premium cards (x.ai dark style)
  const base = 'bg-fit-bg-secondary border border-fit-line rounded-fit-lg transition-all text-fit-text';
  const glass = variant === 'glass' ? 'bg-fit-bg/80 backdrop-blur-md' : '';
  const interactive = onClick ? 'cursor-pointer hover:border-fit-line-strong hover:bg-fit-bg-tertiary hover:-translate-y-0.5 active:scale-[0.99]' : '';

  const classes = [base, glass, interactive, 'animate-slide-up', className].filter(Boolean).join(' ');

  // Always apply padding (default spacing-lg) so cards never collapse to zero padding.
  const dynamicStyle: React.CSSProperties = { padding, ...style };

  return (
    <div 
      onClick={onClick}
      className={classes}
      style={dynamicStyle}
    >
      {children}
    </div>
  );
};

export default Card;
